// externals
import type { FC } from 'react';

// libraries
import { TextInput } from '@interstate/components/TextInput';

// types
import type { CellFinanceDetailsProps } from './types';

// consts/enums
import { NA } from '../common/taxesAndFeesConsts';

export const FinanceCodeCell: FC<CellFinanceDetailsProps> = ({ detail }) => {
    return (
        <TextInput
            name="Code"
            label="Code"
            displayLabel={false}
            className="edit-fee--code-cell edit-fee--code-cell-readonly"
            required
            readOnly
            data-testid={`edit-fee--code-cell-${detail.code}`}
            value={detail.code == null ? NA : `${detail.code}`}
            size={'sm'}
        />
    );
};
